import DataGridMarifer from "components/dataGridMarifer/dataGridMarifer";
import {
  getAllTallasByProductInventory,
  getProductTallbyId,
} from "../functions";
import { DataGrid } from "@mui/x-data-grid";
const { Box, Button } = require("@mui/material");
const { getAllProducts } = require("components-base/productos/functions");
const { default: Card } = require("components/card");
const { useState, useEffect } = require("react");
import { useDispatch } from "react-redux";
import { columns } from "../columns";
import { AddCircle, FileDownload } from "@mui/icons-material";
import StackGarmentDrawer from "./stackGarmentDrawer";
import { setDefaultData } from "store/modules/StackGarment";
import DialogReportGarment from "./DialogReportGarment";
import StackGarmentDelete from "./stackGarmentDelete";

const StackGarmentTable = () => {
  const [open, setOpen] = useState(false);
  const [productoData, setProductoData] = useState([]);
  const [tallasData, setTallasData] = useState([]);
  const [dataColumns, setDataColumns] = useState(null);
  const [mode, setMode] = useState("POST");
  const [openDelete, setOpenDelete] = useState(false);
  const [render, setRender] = useState(false);
  const [fieldValue, setFieldValue] = useState(null);
  const [dataFilter, setDataFilter] = useState(null);
  const [openReport, setOpenReport] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchDataProduct = async () => {
      let dataPoduct = await getAllProducts();
      setProductoData(dataPoduct);
    };
    const fetchDataTallasData = async () => {
      let dataTallas = await getAllTallasByProductInventory();
      setTallasData(dataTallas);
    };
    fetchDataTallasData();
    fetchDataProduct();
    let col = columns(setOpen, setMode, setOpenDelete, dispatch);
    setDataColumns(col);
  }, [render]);

  useEffect(() => {
    const fetchDataPost = async () => {
      if (mode === "POST" && fieldValue !== null) {
        dispatch(setDefaultData({}));
        let data = await getProductTallbyId(fieldValue);
        const rows = data.map((item) => ({
          id: item.id,
          idTalla: item.talla.id,
          idProducto: item.producto.id,
          nombre: item.talla.nombre,
          cantidad: item.cantidad,
          descripcion: item.descripcion,
        }));
        dispatch(
          setDefaultData({
            imagen: data[0].producto.imagen,
            sku: data[0].producto.sku,
            nombre: data[0].producto.nombre,
            tallas: rows,
          })
        );
        setFieldValue(null);
      }
    };
    fetchDataPost();
  }, [mode, fieldValue]);

  const groupByProduct = (array) => {
    const resultado = {};
    array.forEach((item) => {
      const idProducto = item.producto.id;

      if (!resultado[idProducto]) {
        resultado[idProducto] = {
          ...item.producto,
          tallas: [],
          total: 0,
        };
      }

      resultado[idProducto].tallas.push({
        id: item.id,
        idProducto: item.producto.id,
        idTalla: item.talla.id,
        nombre: item.talla.nombre,
        // codigo: item.talla.codigo,
        cantidad: item.cantidad,
        descripcion: item.descripcion,
      });

      resultado[idProducto].total += item.cantidad;
    });
    return Object.values(resultado);
  };

  const handleClose = () => {
    dispatch(setDefaultData({}));
    setOpen(false);
  };

  const handleCloseReport = () => {
    setOpenReport(false);
  };

  const productosAgrupados = groupByProduct(tallasData);

  return (
    <Box sx={{ height: "750px", width: "100%" }}>
      <StackGarmentDelete
        setOpenDelete={setOpenDelete}
        openDelete={openDelete}
        setRender={setRender}
      />
      <StackGarmentDrawer
        open={open}
        handleClose={handleClose}
        mode={mode}
        setRender={setRender}
        productoData={productoData}
        setFieldValue={setFieldValue}
      />
      <DialogReportGarment
        openReport={openReport}
        handleClose={handleCloseReport}
        productosAgrupados={productosAgrupados}
      />
      <Card extra={"w-full h-full p-4"}>
        <div className="relative flex items-center justify-end">
          <div className="w-full text-xl font-bold text-navy-700 dark:text-white">
            <div className="flex justify-end gap-4">
              {" "}
              <Button
                onClick={() => {
                  setMode("POST");
                  setOpen(true);
                }}
              >
                <AddCircle />
                Agregar Nuevo Producto al Inventario
              </Button>
              <Button
                onClick={() => {
                  setOpenReport(true);
                }}
              >
                <FileDownload />
                Descargar Reporte
              </Button>
            </div>
          </div>
        </div>

        {productosAgrupados ? (
          <DataGrid
            className="mt-8 h-max w-full dark:text-white"
            rows={productosAgrupados || []}
            columns={dataColumns || []}
            autoPageSize
            rowsPerPageOptions={[5, 10, 15, 20, 30]}
            checkboxSelection
            disableSelectionOnClick
            getRowHeight={() => "auto"}
          />
        ) : (
          <div className="flex justify-center pt-56">
            <CircularProgress color="primary" />
            <Typography>Cargando datos...</Typography>
          </div>
        )}
      </Card>
    </Box>
  );
};

export default StackGarmentTable;
